import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from '../components/playerflow/PlayerLogin';
import PlayGround from '../components/loginandplay/playground';
import WelcomeScreen from '../components/playerflow/PlayerLobby';
import LoginScreen from '../components/admincomponents/LoginScreen';
import DashboardRouting from '../components/admincomponents';
import PlayerSketcherPlay from '../components/playerflow/PlayerSketcherPlay';

import SignupScreen from '../components/loginandplay/onboarding/SignupScreen';

import SignupConfirmation from '../components/loginandplay/onboarding/SignupConfirmation';
import AssignProfileScreen from '../components/loginandplay/onboarding/AssignProfileScreen';
import SubscriptionScreen from '../components/loginandplay/onboarding/SubscriptionScreen';
import VerificationEmail from '../components/loginandplay/onboarding/VerificationEmail';
import WebsiteHome from '../website/WebsiteHome';
import PrivacyPolicy from '../website/PrivacyPolicy';
import ProtectedRoute from '../hooks/ProtectedRoute';
import PlayerRouteGuard from '../hooks/PlayerRouteGuard';

const RouteNavigation: React.FC = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<WebsiteHome />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/join" element={<Login />} />
        <Route path="/login" element={<LoginScreen />} />
        <Route path="/signup" element={<SignupScreen />} />
        <Route path="/verify-email" element={<VerificationEmail />} />
        <Route path="/signup-confirmation" element={<SignupConfirmation />} />

        {/* Player routes (requires valid game session) */}
        <Route element={<PlayerRouteGuard />}>
          <Route path="/welcome" element={<WelcomeScreen />} />
          <Route path="/playground" element={<PlayGround />} />
          <Route path="/sketcherplayground" element={<PlayerSketcherPlay />} />
        </Route>

        {/* Admin routes (requires authentication) */}
        <Route element={<ProtectedRoute />}>
          <Route path="/profile-subscriber" element={<AssignProfileScreen />} />
          <Route path="/subscription-plan" element={<SubscriptionScreen />} />
          <Route path="/dashboard/*" element={<DashboardRouting />} />
        </Route>
      </Routes>
    </Router>
  );
};

export default RouteNavigation;
